import React from "react";
import {Link} from "gatsby";
import {Button, Card, ExternalIcon} from "components/ui";
const CardContainer = ({title, resources, topicPage, ...rest}) => {
    let resourcesList= topicPage ? resources?.filter(resource=>{
        return (resource?.pdf && (resource?.series?.length < 1 || resource?.series === undefined )) || (resource?.video_url && ( resource?.series === undefined || resource?.videos_webinars_series?.length < 1 || resource?.series?.length < 1 )) || (resource?.external_url_resource && (resource?.series?.length < 1 || resource?.series === undefined )) || (resource?.external_url_resource && (resource?.videos_webinars_series?.length < 1 || resource?.series === undefined )) || (resource?.resources?.length > 0) || (resource?.videos_webinars_series?.length > 0 )
    }) : resources;
    
    const sortCards = list =>{
        let resourcesWithDate=[];
        let resourcesWithoutDate=[];
        list.forEach(resource=>{
            if(resource.resource_date === null){
                resourcesWithoutDate.push(resource)
            } else{
                resourcesWithDate.push(resource)
            }
        })
        resourcesWithDate.sort((a, b) => {
            return Date.parse(b?.resource_date || b?.date)  - Date.parse(a?.resource_date || a?.date)})
        resourcesWithoutDate.sort((a, b) => {
            if (a.title < b.title) {
                return -1;
            }
        });
        return [...resourcesWithDate,...resourcesWithoutDate]
    }
    return (
        <div className={`padding-y-5 ${rest.containerStyle}`}>
            <div className="grid-container">
                {title && <h2 className={`${rest.headerColor}`}>{title}</h2> }
                <div className="usa-card-group">
                    {sortCards(resourcesList)?.map((resource, idx)=>{
                        let resourceTitle = resource?.card_title ?? resource?.title;
                        let characterCount = (resource?.author && resource?.resource_date) ? 136 : 230;
                        let excerpt = resource?.body?.data?.childMarkdownRemark?.excerpt?.replace("…",'');
                    return (
                        <Card key={`${rest.keyName}-${idx + 1}`}
                        grid={rest.grid}
                        background={rest.cardColor}>
                            <Card.Header>
                            {resourceTitle &&
                                <h2 className="usa-card__heading">
                                    {(resource?.card_title && resource?.card_description) ? 
                                        (resourceTitle.length > 38 ? resourceTitle.substring(0,38) + "..." : resourceTitle)
                                    :(resource?.card_title || resource?.title) && 
                                        (resourceTitle.length > 107 ? resourceTitle.substring(0,107) +"..." : resourceTitle)}
                                </h2>
                            }
                            </Card.Header>
                            <Card.Body>
                            {(resource?.video_url && resource?.body) ? 
                                    <>
                                        {resource?.date && <p>Date: {resource?.date.substring(0,70)}</p> }
                                        <span
                                                dangerouslySetInnerHTML={{
                                                __html: excerpt,
                                                }}
                                                className="card-text" 
                                            />... 
                                        <span>(<Link to={`/training/videos-and-webinars/${resource?.slug && resource?.slug}`}>Read More</Link>)</span>
                                    </>
                                :
                                 <p>{`${resource?.author?.substring(0,44) ?? ''}${resource?.author ? (resource?.author?.length > 44 ? `..., `: `, `):""}`}{resource?.author && (resource?.resource_date?.slice(-4) ?? 'n.d.')}</p> 
                                   
                                }
                            {resource.card_description &&
                                <p>{resource?.card_description.substring(0,characterCount)}{(resource?.card_description && resource?.card_description.length > characterCount) && <span>...</span>}</p>
                            }
                            
                            {
                                (!resource?.card_description && !resource?.video_url && resource?.body) &&
                                    resource?.body && 
                                    <>
                                        <span 
                                            dangerouslySetInnerHTML={{ 
                                            __html: excerpt,
                                            }}
                                            className="card-text"
                                        />...
                                        (<Link to={`${resource?.slug}`}>Read More</Link>)
                                    </>   
                                }
                            </Card.Body>
                            <Card.Footer
                            cardFooter="text-center">
                                  {resource?.pdf ?
                                <>
                                    <Button color="primary-button" size="padding-x-5" link={`/files/${resource?.pdf && resource?.pdf?.name}`} labelText={`Open ${resourceTitle} document in a new window`}>
                                        View Document { ` (PDF ${resource?.pdf?.localFile?.prettySize.toUpperCase()})`}
                                    </Button>
                                    {resource?.external_resource && <ExternalIcon /> }
                                </>
                                :
                                resource?.video_url ?
                                <>
                                   <Button color="primary-button" type="button" size="padding-x-5" labelText={`Open ${resource?.title} Video in page`} onClick={rest.buttonOnClick} title={resource?.title}>
                                       Watch Video
                                    </Button>
                                    {resource?.external_resource && <ExternalIcon /> }
                                </>
                                :
                                resource?.external_url_resource ?
                                <>
                                    {resource?.external_file_size ? 
                                        <a href={resource?.external_url_resource && resource?.external_url_resource} className="usa-button primary-button padding-x-5"  aria-label={`Open ${resource?.title} in a new window`} target="_blank" rel="noreferrer">
                                            View Document { resource?.external_file_size &&` (PDF ${resource?.external_file_size})`}
                                        </a>
                                    :
                                        <a href={resource?.external_url_resource && resource?.external_url_resource} className="usa-button primary-button padding-x-5"  aria-label={`Open ${resource?.title} in a new window`} target="_blank" rel="noreferrer">
                                            View Website 
                                        </a>
                                    }
                                    {resource?.external_resource && <ExternalIcon />}
                                </>
                               :
                                <>
                                  <Button color="primary-button" type="button" size="padding-x-5" link={resource?.slug && resource?.slug} labelText={`Learn more About ${resourceTitle}`}>
                                    {(resource?.resources || resource?.videos_webinars_series) ? 'View Series' : 'Learn More' }
                                    </Button>
                                    {resource?.external_resource && <ExternalIcon /> }
                                </>
                                }
                            </Card.Footer>
                        </Card>
                    )
                    })}
                </div>
            </div>
        </div>
    )
}
export default CardContainer;
